import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=6534b471&scoped=true&"
import script from "./PaymentMethod.vue?vue&type=script&lang=js&"
export * from "./PaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethod.vue?vue&type=style&index=0&id=6534b471&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6534b471",
  null
  
)

export default component.exports